export const config = {
  apiKey: import.meta.env.VITE_AMPLITUDE_API_KEY || '',
  nuvempagoApiKey: import.meta.env.VITE_NUVEMPAGO_AMPLITUDE_API_KEY || '',
  nuvempagoInstanceName: 'nuvempago_commons',
};
